import 'styles/apps/personal/components/masthead-qualities.scss';
import React, { Fragment } from 'react';
import { resolve } from 'library/helpers/path-resolver';
import PropTypes from 'prop-types';
import Image from 'library/components/image';
import CssTransition from 'library/structures/css-transition';
import ShareLink from 'library/components/share-link';
import QualitiesLoading from 'apps/personal/components/masthead-qualities-loading';

import DownloadSvg from 'library/icons/download.svg';

const QualityIcon = ({className, link_name, name}) => (
  <div className={`personal-masthead-quality-icon ${className}`}>
    <Image width={375} height={375} style={{maxWidth: '375px',height: '375px'}} src={`${__ASSET_PATH__}/icons/qualities/${link_name}.svg`} />
    <div className="personal-masthead-quality-name">{ name }</div>
  </div>
);

QualityIcon.propTypes = {
  link_name: PropTypes.string,
  name: PropTypes.string,
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object
  ])
};

const CategoryMap = {
  'General Style': 'Leading General Style',
  'Driver': 'Strongest Driver',
  'Social/Emotional IQ': 'Top EQ Competency',
  'Virtue': 'Highest Virtue Class',
  'Thinking Styles': 'Top Thinking Style'
};

export const QualityText = ({category, description, className}) => (
  <div className={`personal-masthead-quality-body ${className}`}>
    <h2>{ CategoryMap[category] }</h2>
    <p>{ description }</p>
  </div>
);

QualityText.propTypes = {
  category: PropTypes.string,
  description: PropTypes.string,
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object
  ])
};

const GetDownloadLink = (qualities) => (
  `${__ASSET_PATH__}/reports/qualities/${[
    resolve(qualities.find(c=>c.category==='Thinking Styles'), 'link_name'),
    resolve(qualities.find(c=>c.category==='Driver'), 'link_name'),
    resolve(qualities.find(c=>c.category==='Social/Emotional IQ'), 'link_name'),
    resolve(qualities.find(c=>c.category==='Virtue'), 'link_name')
  ].join('-')}`
);

export const MastheadControls = ({ userId=null, current_quality, qualities = [] }) => (
  <div className="personal-masthead-qualities-controls">
    <span>
      <span className="hide-on-mobile">{trans`Download Report`}</span> (<a href={`${GetDownloadLink(qualities)}-bw.pdf`} target="_blank">{trans`Plain`}</a> | <a href={`${GetDownloadLink(qualities)}-color.pdf`}  target="_blank">{trans`Full Color`}</a>) <DownloadSvg className="icon" />
    </span>
    <ShareLink userid={userId} text={`'${current_quality.name}' ` + trans`is one of my top qualities. Take the PAIRIN Survey to find out yours. `} link={`https://www.pairin.com/share/${current_quality.link_name}`} />
  </div>
);

MastheadControls.propTypes = {
  userId: PropTypes.number,
  current_quality: PropTypes.object,
  qualities: PropTypes.array
};

export default class MastheadQualities extends React.Component {
  static propTypes = {
    loading: PropTypes.bool,
    qualities: PropTypes.array
  }

  state = {
    index: null
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.qualities && (prevState.index === null || prevState.index >= nextProps.qualities.length)) {
      return {
        index:Math.floor(Math.random() * nextProps.qualities.length)
      };
    }

    return null;
  }

  get current_quality() {
    const current_quality = (this.props.qualities||[])[this.state.index];
    return current_quality;
  }

  mapQualityNavigation = (quality, i) => {
    const className = [
      'personal-masthead-qualities-navigation-item',
      this.current_quality.id === quality.id ? 'active' : null
    ].filter(c=>c).join(' ');
    return (
      <Fragment key={quality.id}>
        <div key={`pre-${quality.id}`} className="personal-masthead-qualities-navigation-spacer" />
        <div
          key={`dot-${quality.id}`}
          onClick={()=>this.setState({index:i})}
          className={className}
        />
        <div key={`post-${quality.id}`} className="personal-masthead-qualities-navigation-spacer" />
      </Fragment>
    );
  }

  render() {
    const {
      loading,
      qualities
    } = this.props;

    if (loading) {
      return <QualitiesLoading />;
    }

    if (!this.current_quality) {
      return null;
    }

    const current_quality = this.current_quality;

    return (
      <div className="personal-masthead-qualities">
        <div className="personal-masthead-quality-left">
          <CssTransition
            transitionName="personal-masthead-quality"
            transitionEnterTimeout={500}
            transitionLeaveTimeout={500}
          >
            <QualityIcon key={current_quality.id} {...current_quality} />
          </CssTransition>
        </div>

        <div className="personal-masthead-quality-right">
          <CssTransition
            transitionName="personal-masthead-quality"
            transitionEnterTimeout={500}
            transitionLeaveTimeout={500}
          >
            <QualityText key={current_quality.id} {...current_quality} />
          </CssTransition>

          <div key="footer" className="personal-masthead-quality-footer">
            <div
              className="personal-masthead-qualities-navigation"
            >
              { qualities.map(this.mapQualityNavigation) }
            </div>
            <MastheadControls current_quality={current_quality} qualities={qualities} />
          </div>
        </div>
      </div>
    );
  }
}
